import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { useAppSelector } from "src/store";
import { createTestimonialSaga } from "src/store/testimonials/saga";
import * as Yup from "yup";

const TestimonialCreateForm = ({
  onHide,
  open,
  onSuccessClick,
}: {
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const languages = useAppSelector((s) => s.language.languages);

  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("Testimonial.CreateFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          NameSurname: "",
          Message: "",
          AvatarFile: "",
          Translates: languages.map((x) => {
            return { LanguageId: x.EnumId, Message: "", NameSurname: "" };
          }),
        }}
        validationSchema={Yup.object().shape({
          // NameSurname: Yup.string().required(
          //   t("Validation.Required").toString()
          // ),
          // Message: Yup.number().required(t("Validation.Required").toString()),
          // Translates: Yup.array(
          //   Yup.object({
          //     Message: Yup.string().required(
          //       t("Validation.Required").toString()
          //     ),
          //     NameSurname: Yup.string().required(
          //       t("Validation.Required").toString()
          //     ),
          //   })
          // ),
        })}
        multilanguageinputs={[
          {
            field: "NameSurname",
            label: t("Testimonial.NameSurname").toString(),
          },
          {
            field: "Message",
            label: t("Testimonial.Message").toString(),
            type: "textarea",
          },
        ]}
        inputs={[
          {
            field: "AvatarFile",
            fileField: "ImageFileField",
            label: t("Testimonial.Avatar").toString(),
            type: "file",
          },
        ]}
        onSubmit={(values) => {
          dispatch(
            createTestimonialSaga({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              body: values,
            })
          );
        }}
      />
    </React.Fragment>
  );
};
export default TestimonialCreateForm;
